package ai.flowstorm.studio.resources

import ai.flowstorm.common.id.Id
import ai.flowstorm.common.resources.AbstractResource
import ai.flowstorm.core.tts.TtsResponse
import ai.flowstorm.studio.model.Session
import io.kvision.rest.HttpMethod
import kotlinx.serialization.Serializable

object ConversationalPlayerResource : AbstractResource<ConversationalPlayerResource.Request>(serializer = Request.serializer()) {
    @Serializable
    data class Request(
        val session: Session,
        val firstTtsConfigId: Id,
        val secondTtsConfigId: Id
    )

    suspend fun synthesize(request: Request): TtsResponse {
        request.session.turns = request.session.turns.map { t ->
            t.input = t.input.copy(tokens = listOf())
            t.copy(endFrame = null)
        }
        return remoteCall(
            "conversationalPlayer/synthesize",
            request,
            HttpMethod.POST,
            TtsResponse.serializer(),
            doToast = false
        )
    }

}